// Shared bits for the staff tracking screens (live map, route history, task panel).

export const STATUS_META = {
    live: { label: "Live", color: "#1a9a5b", badge: "badge-active" },
    delayed: { label: "Delayed", color: "#e6a100", badge: "badge-warning" },
    offline: { label: "No signal", color: "#8a8f98", badge: "badge-inactive" },
};

export const TASK_COLOR = "#f16436";
export const SHIFT_COLOR = "#3b6fd4";

export const initials = (name) => {
    const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
    return parts.length ? (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase() : "?";
};

export const toLatLng = (point) => {
    const lat = Number(point?.lat);
    const lng = Number(point?.lng);
    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

// "12 s ago", "3 min ago", "2 h ago" from a time.
export const agoText = (time, now = Date.now()) => {
    const seconds = Math.max(0, Math.round((now - new Date(time).getTime()) / 1000));
    if (!Number.isFinite(seconds)) return "-";
    if (seconds < 60) return `${seconds} s ago`;
    if (seconds < 3600) return `${Math.round(seconds / 60)} min ago`;
    if (seconds < 86400) return `${Math.round(seconds / 3600)} h ago`;
    return `${Math.round(seconds / 86400)} d ago`;
};

export const metresText = (metres) => {
    if (!Number.isFinite(metres)) return "-";
    return metres >= 1000 ? `${(metres / 1000).toFixed(1)} km` : `${Math.round(metres)} m`;
};

export const durationText = (from, to) => {
    const minutes = Math.round((new Date(to) - new Date(from)) / 60000);
    if (!Number.isFinite(minutes) || minutes < 0) return "-";
    if (minutes < 60) return `${minutes} min`;
    return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
};

// A round map pin: filled with the status colour, ringed in orange while on a task.
export const pinIcon = (google, { color, ring = false, scale = 12 }) => ({
    path: google.maps.SymbolPath.CIRCLE,
    scale,
    fillColor: color,
    fillOpacity: 1,
    strokeColor: ring ? TASK_COLOR : "#ffffff",
    strokeWeight: ring ? 4 : 2,
});

export const fitTo = (map, google, points, padding = 60) => {
    const list = points.filter(Boolean);
    if (!map || !google || !list.length) return;
    if (list.length === 1) {
        map.setCenter(list[0]);
        map.setZoom(16);
        return;
    }
    const bounds = new google.maps.LatLngBounds();
    list.forEach((p) => bounds.extend(p));
    map.fitBounds(bounds, padding);
};

// <input type="datetime-local"> wants local time as YYYY-MM-DDTHH:mm.
export const toLocalInput = (date) => {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const PROBLEM_TEXT = {
    gone_quiet: "Stopped sending location",
    never_reported: "Has not sent any location since starting",
    tracking_off: "Location sharing is switched off",
};

export const MAP_STYLE = { width: "100%", height: "100%" };
export const MAP_OPTIONS = { streetViewControl: false, mapTypeControl: false, fullscreenControl: true, clickableIcons: false };
